import { render, staticRenderFns } from "./BrowserDefaultsValidation.vue?vue&type=template&id=1d59df7c&"
import script from "./BrowserDefaultsValidation.vue?vue&type=script&lang=js&"
export * from "./BrowserDefaultsValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports